import api from './axiosConfig';
export const getCategories      = ()         => api.get('/api/v1/questions/categories');
export const listQuestions      = (params)   => api.get('/api/v1/questions',                { params });
export const createQuestion     = (data)     => api.post('/api/v1/questions',               data);
export const getQuestion        = (id)       => api.get(`/api/v1/questions/${id}`);
export const updateQuestion     = (id, d)    => api.put(`/api/v1/questions/${id}`,          d);
export const deleteQuestion     = (id)       => api.delete(`/api/v1/questions/${id}`);
export const generateQuestions  = (data)     => api.post('/api/v1/ai/generate-questions',  data);
export const refineQuestion     = (data)     => api.post('/api/v1/ai/refine-question',      data);
